import { Section } from '../../../../../../Model/CoachNotificationView';

import texts from './texts.json';

const getColumns = ({
  actionsRenderCell,
  itemRenderCell,
  itemValueGetter,
  extraColumns = [],
}) => [
  {
    field: 'name',
    type: 'string',
    headerName: texts.columns.coachName,
    quickSearch: true,
    flex: 2,
  },
  ...extraColumns,
  {
    field: 'chats',
    type: 'string',
    headerName: texts.sections[Section.CHATS],
    flex: 2,
    renderCell: ({ row: { id, chats } }) => itemRenderCell({
      path: `/c/${id}/chat`,
      data: chats ?? {},
      coachId: id,
      section: Section.CHATS,
    }),
    valueGetter: ({ row }) => itemValueGetter({
      sectionData: row.chats,
      coachId: row.id,
      section: Section.CHATS,
    }),
  },
  {
    field: 'checkins',
    type: 'string',
    headerName: texts.sections[Section.CHECKINS],
    flex: 2,
    renderCell: ({ row: { id, checkins } }) => itemRenderCell({
      path: `/c/${id}/feed?type=checkins`,
      data: checkins ?? {},
      coachId: id,
      section: Section.CHECKINS,
    }),
    valueGetter: ({ row }) => itemValueGetter({
      sectionData: row.checkins,
      coachId: row.id,
      section: Section.CHECKINS,
    }),
  },
  {
    field: 'workouts',
    type: 'string',
    headerName: texts.sections[Section.WORKOUTS],
    flex: 2,
    renderCell: ({ row: { id, workouts } }) => itemRenderCell({
      path: `/c/${id}/feed?type=workouts`,
      data: workouts ?? {},
      coachId: id,
      section: Section.WORKOUTS,
    }),
    valueGetter: ({ row }) => itemValueGetter({
      sectionData: row.workouts,
      coachId: row.id,
      section: Section.WORKOUTS,
    }),
  },
  {
    field: 'mealPlans',
    type: 'string',
    headerName: texts.sections[Section.MEAL_PLANS],
    flex: 2,
    renderCell: ({ row: { id, mealPlans } }) => itemRenderCell({
      path: `/c/${id}/feed?type=mealplans`,
      data: mealPlans ?? {},
      coachId: id,
      section: Section.MEAL_PLANS,
    }),
    valueGetter: ({ row }) => itemValueGetter({
      sectionData: row.mealPlans,
      coachId: row.id,
      section: Section.MEAL_PLANS,
    }),
  },
  {
    field: 'videoFeedback',
    type: 'string',
    headerName: texts.sections[Section.VIDEO_FEEDBACK],
    flex: 2,
    renderCell: ({ row: { id, videoFeedback } }) => itemRenderCell({
      path: `/c/${id}/feed?type=feedback`,
      data: videoFeedback ?? {},
      coachId: id,
      section: Section.VIDEO_FEEDBACK,
    }),
    valueGetter: ({ row }) => itemValueGetter({
      sectionData: row.videoFeedback,
      coachId: row.id,
      section: Section.VIDEO_FEEDBACK,
    }),
  },
  {
    field: 'reminders',
    type: 'string',
    headerName: texts.sections[Section.REMINDERS],
    flex: 2,
    renderCell: ({ row: { id, reminders } }) => itemRenderCell({
      path: `/c/${id}/feed?type=special`,
      data: reminders ?? {},
      coachId: id,
      section: Section.REMINDERS,
    }),
    valueGetter: ({ row }) => itemValueGetter({
      sectionData: row.reminders,
      coachId: row.id,
      section: Section.REMINDERS,
    }),
  },
  {
    field: 'routing',
    type: 'string',
    headerName: texts.sections[Section.ROUTING],
    flex: 2,
    renderCell: ({ row: { id, routing } }) => itemRenderCell({
      path: `/c/${id}/chat?focusMessageId=${routing?.lastFlaggedMessageId ?? ''}`,
      data: routing ?? {},
      coachId: id,
      section: Section.ROUTING,
    }),
    valueGetter: ({ row }) => itemValueGetter({
      sectionData: row.routing,
      coachId: row.id,
      section: Section.ROUTING,
    }),
  },
  {
    field: 'actions',
    headerName: texts.columns.actions,
    width: 150,
    renderCell: actionsRenderCell,
  },
];

export default getColumns;
